import { useEffect } from 'react';
import generate from '../configs/Colors/generate.es.js';
import { themeColor } from '../configs/Colors/index.es.js';
import { defaultTheme } from '../configs/Theme/index.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const formatDateTime = (date, type) => {
  const dateStr = date.toLocaleDateString("en-GB");
  const timeStr = date.toLocaleTimeString("vi-VN").slice(0, 5);
  switch (type) {
    case "date":
      return dateStr;
    case "time":
      return timeStr;
    default:
      return `${dateStr} ${timeStr}`;
  }
};
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const refs = Array.isArray(ref) ? ref : [ref];
      if (!refs.some((ref2) => ref2.current) || refs.some((e) => {
        var _a;
        return (_a = e.current) == null ? void 0 : _a.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    document.addEventListener("click", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("click", listener);
    };
  }, [ref, handler]);
};
const generateTheme = (baseColor) => {
  return __spreadProps(__spreadValues({}, defaultTheme), {
    colors: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, themeColor), generate(baseColor.primary, "primary")), generate(baseColor.secondary, "secondary")), baseColor.link && generate(baseColor.link, "link"))
  });
};
const pixelParse = (value) => {
  if (typeof value === "number")
    return `${value}px`;
  return value;
};
const getScrollbarWidth = () => {
  var _a;
  let width = 0;
  if (typeof window !== "undefined") {
    if (document.body.scrollHeight <= window.innerHeight)
      return 0;
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    (_a = outer.parentNode) == null ? void 0 : _a.removeChild(outer);
  }
  return width;
};
const toArray = (candidate) => {
  if (candidate === void 0 || candidate === false)
    return [];
  return Array.isArray(candidate) ? candidate : [candidate];
};
const omit = (obj, fields) => {
  const clone = __spreadValues({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach((key) => {
      delete clone[key];
    });
  }
  return clone;
};
const mergeCls = (...cls) => {
  return cls.filter(Boolean).join(" ");
};
const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
const getElementOffset = (elem) => {
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top, left };
};
const isNotNullOrUndefinedElement = (val) => !!val;

export { formatDateTime, generateTheme, getElementOffset, getScrollbarWidth, isNotNullOrUndefinedElement, mergeCls, omit, pixelParse, toArray, uid, useClickOutside };
